<template>
  <div id="addressMapContainer">
    <div class="addressContainer">
      <div>
        <div class="subTitle">주소를 입력해주세요!</div>
        <div class="addressInputContainer">
          <input
              v-model="searchText"
              class="addressTextInput"
              style="width:100%"
              @keyup.enter="onSearch"
          >
          <div class="searchButton" @click="onSearch">
            <img src="../../../../public/icons/search.svg">
          </div>
        </div>
      </div>
      <div class="divider"></div>
      <div
          v-for="(item, index) in addressList"
          :key="index"
          class="addressItem"
          @click="onClickAddress(item)"
      >
        <div class="jibunContainer">
          <div class="addressTypeChip">지번</div>
          <div class="addressText">{{item.address ? item.address.address_name : '-'}}</div>
        </div>
        <div class="roadContainer">
          <div class="addressTypeChip">도로명</div>
          <div class="addressText">{{item.road_address.address_name}}</div>
        </div>
      </div>
    </div>
    <div class="buttonContainer">
      <div class="cancelButton" @click="onCancel">취소</div>
      <div class="saveButton" @click="onSave">저장</div>
    </div>
    <div id="kakaoMap"></div>

  </div>
</template>

<script>
import {api} from "../../../mixins/api";
import {mapMutations, mapState} from "vuex";

export default {
  name: "addressMapComponent",
  computed: {
    ...mapState(["kakaoAddressInfo"])
  },
  mounted() {
    this.setKakaoAddressInfo({});

    let self = this;
    setTimeout(() => {
      let container = document.getElementById('kakaoMap');
      let options = {

        center: new kakao.maps.LatLng(33.450701, 126.570667),
        level: 3
      };

      self.map = new kakao.maps.Map(container, options);
      kakao.maps.event.removeListener(self.map, 'click');
      kakao.maps.event.addListener(self.map, 'click', function(mouseEvent) {
        // 클릭한 위도, 경도 정보를 가져옵니다
        let latLng = mouseEvent.latLng;
        self.createMarker(latLng)
      });

      // 주소-좌표 변환 객체를 생성합니다
      self.geocoder = new kakao.maps.services.Geocoder();
    }, 10);
  },
  data() {
    return {
      addressList: [],
      searchText: null,
      map: null,
      marker: null,
      geocoder: null,
      infoWindow: null
    }
  },
  methods: {
    ...mapMutations(["setShowMap", "setKakaoAddressInfo", "updateKakaoAddressBjdInfo"]),
    createMarker(coord) {
      var markerPosition  = new kakao.maps.LatLng(coord.getLat(), coord.getLng());
      if (this.marker) {
        this.marker.setMap(null);
      } else {

        this.marker = new kakao.maps.Marker({
          position: markerPosition
        });
      }

      this.marker.setPosition(markerPosition)
      this.marker.setMap(this.map);
      this.marker.setDraggable(true);

      this.createWindow();


    },
    createWindow() {
      let self = this;
      this.searchDetailAddrFromCoords(this.marker.getPosition(), (result, status) => {
        if (status === kakao.maps.services.Status.OK) {
          if (self.infoWindow) {
            self.infoWindow.setMap(null);
          } else {
            self.infoWindow = new kakao.maps.InfoWindow({
              xindex: 1,
            });
          }




          let coord = this.marker.getPosition();
          this.setKakaoAddressInfo({
            requestedAddress: this.searchText || "",
            latY: coord.getLat(),
            lonX: coord.getLng(),
            addressBjd: result[0].address.address_name,
            addressRoad: result[0].road_address ? result[0].road_address.address_name : null,
            sd: result[0].address.region_1depth_name,
            sgg: result[0].address.region_2depth_name,
            emd: result[0].address.region_3depth_name,
            bunjiMountain: result[0].address.mountain_yn,
            bunjiMain: result[0].address.main_address_no,
            bunjiSub: result[0].address.sub_address_no
          });

          this.searchRegionCodeFromCoords(this.marker.getPosition(), (result, status) => {
            if (status === kakao.maps.services.Status.OK) {
              console.log('지역 명칭 : ' + result[0].code);
              this.updateKakaoAddressBjdInfo(result[0].code);

              let addressInfo = this.kakaoAddressInfo;
              let detailAddr = '<div style="margin-left: 6px;">지번 주소 : ' + addressInfo.addressBjd + '</div>';
              detailAddr += '<div style="margin-left: 6px;">도로명주소 : ' + (addressInfo.addressRoad || '-') + '</div>';
              detailAddr += `<div style="margin-left: 6px;">PNU : ${result[0].code}${addressInfo.bunjiMountain === "N" ? '1' : '2'}${addressInfo.bunjiMain.padStart(4, 0)}${addressInfo.bunjiSub.padStart(4, 0)}</div>`;


              let content = '<div class="bAddr" style="width: 400px;height:100px;margin-bottom: 4px;">' +
                  '<span class="title" style="margin-left:4px;">법정동 주소정보</span>' +
                  detailAddr +
                  '</div>';

              self.infoWindow.setContent(content);
              self.infoWindow.open(self.map, self.marker);

            }
          });
        }
      });
    },
    onClickAddress(item) {
      let coord = new kakao.maps.LatLng(item.y, item.x);
      this.createMarker(coord)

      // 지도 중심을 이동 시킵니다
      this.map.setCenter(coord);
    },
    searchDetailAddrFromCoords(coord, callback) {
      // 좌표로 법정동 상세 주소 정보를 요청합니다
      this.geocoder.coord2Address(coord.getLng(), coord.getLat(), callback);
    },
    searchRegionCodeFromCoords(coord, callback) {
      // 좌표로 법정동 정보를 얻는다.
      this.geocoder.coord2RegionCode(coord.getLng(), coord.getLat(), callback);
    },
    async onSearch() {
      this.addressList = [];
      let r = await api.methods.kakaoLocationApi(this.searchText);
      this.addressList = r.documents || [];
    },
    onCancel() {
      // this.setKakaoAddressInfo({});
      this.setShowMap(false);
    },
    onSave() {
      if (this.marker) {
        this.setShowMap(false);
      } else {
        alert('지도를 클릭해주세요.');
      }
    }
  }
}
</script>

<style scoped>
#addressMapContainer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: calc(100%);
  /*background: blue;*/
  z-index: 100;
  display: flex;
}

.addressContainer {
  width: 487px;
  height: calc(100% - 100px);
  background: #FFFFFF;
  box-shadow: 0px 4px 40px rgba(51, 51, 51, 0.1);
  padding: 48px 0 30px 32px;
  overflow-x: hidden;
  overflow-y: scroll;
  /*margin-bottom: 12px;*/

}

.addressItem {
  width: 423px;
  height: 114px;
  background: #FAFAFA;
  /* hyundai/black */

  border: 1px solid #333333;
  box-sizing: border-box;
  border-radius: 8px;
  padding: 28px;
  margin-bottom: 16px;
}

.addressItem:hover {
  cursor: pointer;
  background: rgba(0, 0, 0, 0.05);
}

.jibunContainer {
  display: flex;
  align-items: center;
}

.roadContainer {
  display: flex;
  align-items: center;
  margin-top: 14px;
}

.addressTextInput {
  display: flex;
  align-items: center;
  padding: 0 20px;
  max-width: 370px;
  height: 50px;
  background: #FAFAFA;
  border: 1px solid #E9EAEC;
  box-sizing: border-box;
  border-radius: 8px;
  font-size: 16px;
  line-height: 16px;
  letter-spacing: -0.6px;
  color: #A5A5A5;
}

.addressTypeChip {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 44px;
  height: 22px;
  font-size: 14px;
  line-height: 14px;
  letter-spacing: -0.6px;
  color: #A5A5A5;
  background: #FFFFFF;
  border: 1px solid #C4C4C4;
  box-sizing: border-box;
  border-radius: 4px;
}

.addressText {
  font-size: 16px;
  line-height: 16px;
  letter-spacing: -0.6px;
  color: #424242;
  margin-left: 8px;
}

.subTitle {
  font-size: 16px;
  line-height: 16px;
  letter-spacing: -0.6px;
  color: #333333;
  margin-bottom: 16px;
}

.addressInputContainer {
  display: flex;
}

.searchButton {
  margin-left: 12px;
  background: #333333;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.searchButton:hover {
  cursor: pointer;
}


.buttonContainer {
  position: absolute;
  bottom:0;
  left:0;
  height: 100px;
  width: 487px;
  background: #FFFFFF;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.cancelButton {
  background: #FFFFFF;
  /* hyundai/black */

  border: 1px solid #333333;
  box-sizing: border-box;
  border-radius: 100px;
  font-size: 18px;
  line-height: 18px;
  letter-spacing: -0.474667px;
  color: #333333;
  padding: 18px 60px;
}

.cancelButton:hover {
  cursor: pointer;
  background: rgba(0, 0, 0, 0.03);
}

.saveButton {
  padding: 18px 60px;
  background: #333333;
  border-radius: 100px;
  font-size: 18px;
  line-height: 18px;
  letter-spacing: -0.474667px;
  color: #FFFFFF;
  margin-left: 16px;
  margin-right: 24px;
}

.saveButton:hover {
  cursor: pointer;
  background: rgba(0, 0, 0, 0.9);
}

.divider {
  margin: 10px 0;
  border-bottom: 1px solid #333333;
  max-width: 430px;
}

#kakaoMap {
  width: calc(100% - 487px);
  height: calc(100%);
}
</style>
